import ElecsumGreenPage from './ElecsumGreenPage';

export default ElecsumGreenPage;
